export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_28-25bbbe2ecb9fcd89e3c2cd7d0c08c052.jpg";